import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { InfoOutlined } from "@material-ui/icons";
import PropTypes from "prop-types";

import { useStyles } from "./ToolTip.styles";

const ToolTip = ({ label }) => {
  const classes = useStyles();

  return (
    <Tooltip arrow classes={classes} title={label}>
      <InfoOutlined></InfoOutlined>
    </Tooltip>
  );
};

ToolTip.defaultProps = {
  label: "",
};

ToolTip.propTypes = {
  label: PropTypes.string,
};

export { ToolTip };
